import React from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'

export default function CircularProgressWithLabel(props) {
  const style = props.style || {}

  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" value={props.value} style={style.progress} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
          style={style.label}
        >
          {props.children}
        </Typography>
      </Box>
    </Box>
  );
}
